import { ApiResponseSuccess, getDeviceLogList } from '@/services';
import { TGetDeviceLogListResponse } from '@/services/api/api.type';
import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import { formatDeviceLogList } from './device-log.helper';
import { DeviceLogActions } from './device-log.redux';
import { IPayloadGetDeviceLogListRequest } from './device-log.type';
export function* getDeviceLogListSaga(
	action: PayloadAction<IPayloadGetDeviceLogListRequest>
) {
	const { callback, ...params } = action.payload;

	try {
		const res: ApiResponseSuccess<TGetDeviceLogListResponse> =
			yield getDeviceLogList({ ...params });
		const total = res?.data?.total || 0;
		const list = formatDeviceLogList(res?.data?.content || [], {
			total,
			page: params.page || 1,
			pageSize: params.pageSize || 10,
		});

		yield put(
			DeviceLogActions.getDeviceLogListSuccess({
				list,
				totalCount: total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(DeviceLogActions.getDeviceLogListFailure());
	}
}
